import { UPDATE_COUNTER, MESSAGING_INBOX_COUNTER } from '../constants/actionTypes'

const INITIAL_STATE = {
    myEvents: null,
    inboxCounter: null,
      
  };

  const updateCounter = (state, action) => {
    //console.log('action in reducer', action)
    return ({
    ...state,
    [action.payload.counterName]: action.payload.count
  })}

  function counterReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      case UPDATE_COUNTER : {
        return updateCounter(state, action);
      }
      case MESSAGING_INBOX_COUNTER : {
        return ({
          ...state,
          inboxCounter: action.inboxCounter
        })
      }
      default : return state;
    }
  }
  
  export default counterReducer;


// WEBPACK FOOTER //
// ./src/reducers/counter.js